import { Box, Container, Typography } from "@mui/material";
import InquiryForm from "../components/InquiryForm"; // adjust to wherever InquiryForm actually lives
import React from "react";
export default function ContactPage() {
    return (React.createElement(Container, { maxWidth: "md" },
        React.createElement(Box, { sx: { textAlign: "center", pt: { xs: 4, sm: 6 }, pb: { xs: 2, sm: 3 } } },
            React.createElement(Typography, { variant: "h3", component: "h1", gutterBottom: true }, "Let's Work Together"),
            React.createElement(Typography, { variant: "body1", color: "text.secondary", sx: { maxWidth: 480, mx: "auto" } }, "Tell me a bit about what you're looking for \u2014 the date, the vibe, who's involved \u2014 and I'll get back to you within a couple of days.")),
        React.createElement(Box, { sx: { pb: { xs: 4, sm: 6 } } },
            React.createElement(InquiryForm, null))));
}
